import { HubConnection } from '@microsoft/signalr';

import { inject, Injectable } from '@angular/core';

import { WsService } from '@ng-gems/api';

import { AppInfo } from '@models/app-info.model';

import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketEventService {
  private hubConnection: HubConnection;
  private wsService = inject(WsService);
  private notificationService = inject(NotificationService);

  openThreadHubSocket(appInfo: AppInfo, accessToken: string) {
    if (!this.hubConnection) {
      this.hubConnection = this.wsService.getWsMidbackPortalThread(appInfo.apiEnvironment, accessToken).openThreadHubSocket();
    }
    return this.hubConnection;
  }

  public listenToNotifications() {
    this.hubConnection.on('ReceiveNewNotifications', () => this.notificationService.triggerNewNotifications());
  }
}
